import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function Information({ user, url }) {

  function openChatInNewWindow() {

    // Escapar adecuadamente los componentes URL
    const esc = (s) => encodeURIComponent(s).replace(/\+/g, '%2B').replace(/ /g, '+').replace(/%20/g, '+');
    
    // Añadir dinámicamente la ubicación actual y el referente
    url += '&location=' + esc(window.location ? window.location.href : '');
    url += '&referrer=' + esc(document.referrer ? document.referrer : '');
  
    // Suponiendo que 'extra' es un objeto que puedes definir según sea necesario
    const extra = {}; // Definir o modificar según los datos adicionales requeridos
    
    if(typeof(extra) === 'object' && typeof(extra.args) === 'object') {
      for(let a in extra.args) {
        url += '&' + esc(a) + '=' + esc(extra.args[a]);
      }
    }
    
    // Abrir la ventana de chat
    window.open(url, '_islpronto_chat_' + Math.floor(Math.random() * 10000000), 'status=no,toolbar=no,menubar=no,resizable=yes,location=no,width=540,height=680');
  }

  return (
    <Box sx={{ marginLeft: '100px', width: '360px', padding: '35px' }}>
      <Typography variant="h4" sx={{ color: 'white', mb: 2 }}>
        Bienvenid@, {user}
      </Typography>

      <Typography sx={{ color: 'white', mb: 2 }}>
        Para comenzar a usar el servicio, pulsa el botón de abajo.
      </Typography>

      <Button
        variant="contained"
        color="error"
        endIcon={<ArrowForwardIosIcon />}
        onClick={openChatInNewWindow}
      >
        Inicia Chat
      </Button>
    </Box>
  );
}

export default Information;
